import { Link } from 'react-router-dom';
import styles from './index.module.css';

const PageHeader = () => (
  <div className={styles.header}>
    <Link to="/" className={styles.closeIcon}></Link>
    <div className={styles.dividend}></div>
    <div className={styles.eddTitle}>Estimated Delivery Date</div>
  </div>
);

export { PageHeader };
